/** @format */
import React, { useContext, useEffect, useState } from 'react';
import { LEVEL_ID, TITLE } from '../../Context/filterCompo/filterTypes';
import { MainContext } from '../../Context/FilterContext/FilterContext';
import { AuthContext } from '../../Context/AuthContext';
import debounce from 'debounce-promise';
import Dropdown from '../Misc/Dropdown';
import FilterBadges from './FilterBadges';
import { CircularProgress } from '@mui/material';
import { TITLEABB } from '../../Data/TitleAbb';

function toTitleCase(str) {
	return str.toLowerCase().replace(/\b\w/g, function (char) {
		return char.toUpperCase();
	});
}

const JobTitleFilter = () => {
	const [expanded, setExpanded] = useState(false);

	const {
		globalSelectFilter,
		setGlobalSelectFilter,
		globalFilterKeyToApi,
		globalFilterKeyTofilterKey,
	} = useContext(MainContext);

	const {
		dispatch,
		setFilter,
		filter,
		setSortField,
		setFirstTimeFilter,
		setFirstTimeApiCall,
		anyFilterFlag,
	} = useContext(AuthContext);

	const [levelId, setLevelId] = useState([]);
	const [department, setDepartment] = useState([]);
	const [titleOptions, setTitleOptions] = useState([]);
	const [firstRender, setFirstRender] = useState(false);
	const [firstTimeRun, setFirstTimeRun] = useState(false);
	const [isTitleSearch, setIsTitleSearch] = useState(false);
	const [isLevelSearch, setIsLevelSearch] = useState(false);
	const [isDepartmentSearch, setIsDepartmentSearch] = useState(false);
	const [isOpen2, setIsOpen2] = useState(false);
	const [isOpen3, setIsOpen3] = useState(false);

	const getTitle = debounce((searchValue) => {
		setIsTitleSearch(true);
		const getData = async () => {
			let abb = '';
			if (searchValue) {
				abb = TITLEABB[searchValue.toUpperCase()];
			}
			const data = await globalFilterKeyToApi[TITLE](abb || searchValue);
			const options = data.map((item) => {
				return {
					value: item.name,
					label: item.name,
				};
			});
			setTitleOptions(options);
			setIsTitleSearch(false);
			return options;
		};
		getData();
	}, 300);

	const getLevelId = (searchValue) => {
		const getData = async () => {
			setIsLevelSearch(true);
			const data = await globalFilterKeyToApi[LEVEL_ID](searchValue);
			const options = data.map((item) => {
				return {
					value: item.name,
					label: item.name,
				};
			});
			setLevelId(options);
			setIsLevelSearch(false);
		};
		getData();
	};

	const handleSelect = (field, selectedOption) => {
		setFirstTimeFilter({
			filterCount: 0,
			isFilterCall: false,
		});

		setGlobalSelectFilter((prev) => {
			if (!prev[field] || prev[field]?.length === 0) {
				return { ...prev, [field]: [selectedOption.value] };
			} else {
				const index = prev[field]?.findIndex((item) => {
					if (typeof item === 'string') {
						return item === selectedOption.value;
					} else {
						return item.value === selectedOption.value;
					}
				});

				if (index !== -1) {
					const updatedArray = [...prev[field]];
					updatedArray.splice(index, 1);
					return { ...prev, [field]: updatedArray };
				} else {
					return { ...prev, [field]: [...prev[field], selectedOption.value] };
				}
			}
		});
		setFilter((prev) => {
			if (!prev[field] || prev[field]?.length === 0) {
				return { ...prev, [field]: [selectedOption.value] };
			} else {
				const index = prev[field]?.findIndex((item) => {
					if (typeof item === 'string') {
						return item === selectedOption.value;
					} else {
						return item.value === selectedOption.value;
					}
				});
				if (index !== -1) {
					const updatedArray = [...prev[field]];
					updatedArray.splice(index, 1);
					return { ...prev, [field]: updatedArray };
				} else {
					return { ...prev, [field]: [...prev[field], selectedOption.value] };
				}
			}
		});

		setSortField({});
	};

	const handleRemove = (field, value) => {
		setFilter((prev) => {
			const index = prev[field]?.findIndex((item) => {
				if (typeof item === 'string') {
					return item === value;
				} else {
					return item.value === value;
				}
			});

			if (index !== -1) {
				const updatedArray = [...prev[field]];
				updatedArray.splice(index, 1);
				return { ...prev, [field]: updatedArray };
			} else {
				return { ...prev };
			}
		});
		setGlobalSelectFilter((prev) => {
			const index = prev[field]?.findIndex((item) => {
				if (typeof item === 'string') {
					return item === value;
				} else {
					return item.value === value;
				}
			});
			if (index !== -1) {
				const updatedArray = [...prev[field]];
				updatedArray.splice(index, 1);
				return { ...prev, [field]: updatedArray };
			} else {
				return { ...prev };
			}
		});
	};

	const handleSelectAll = () => {
		setFirstTimeFilter({
			filterCount: 0,
			isFilterCall: false,
		});

		var field = 'levelID';

		if (filter?.levelID?.length === 5) {
			setGlobalSelectFilter((prev) => {
				return { ...prev, levelID: [] };
			});
			setFilter((prev) => {
				return { ...prev, levelID: [] };
			});
		} else {
			for (const selectedOption of levelId) {
				setGlobalSelectFilter((prev) => {
					if (!prev[field] || prev[field]?.length === 0) {
						return { ...prev, [field]: [selectedOption.value] };
					} else {
						const index = prev[field]?.findIndex((item) => {
							return item === selectedOption.value;
						});

						if (index !== -1) {
							return { ...prev };
						} else {
							return {
								...prev,
								[field]: [...prev[field], selectedOption.value],
							};
						}
					}
				});
				setFilter((prev) => {
					if (!prev[field] || prev[field]?.length === 0) {
						return { ...prev, [field]: [selectedOption.value] };
					} else {
						const index = prev[field]?.findIndex((item) => {
							return item === selectedOption.value;
						});

						if (index !== -1) {
							return { ...prev };
						} else {
							return {
								...prev,
								[field]: [...prev[field], selectedOption.value],
							};
						}
					}
				});
			}
		}

		setSortField({});
	};

	const handleMostSearchML = () => {
		setFirstTimeFilter({
			filterCount: 0,
			isFilterCall: false,
		});

		var field = 'levelID';

		if (
			filter?.levelID?.length === 3 &&
			['C-Level', 'Manager-Level', 'VP-Level'].every((value) => {
				return filter?.levelID.some((element) => {
					return element === value;
				});
			})
		) {
			setGlobalSelectFilter((prev) => {
				return { ...prev, levelID: [] };
			});
			setFilter((prev) => {
				return { ...prev, levelID: [] };
			});
		} else {
			for (const selectedOption of levelId) {
				if (
					selectedOption.value === 'C-Level' ||
					selectedOption.value === 'Manager-Level' ||
					selectedOption.value === 'VP-Level'
				) {
					console.log(selectedOption);
					setGlobalSelectFilter((prev) => {
						if (!prev[field] || prev[field]?.length === 0) {
							return { ...prev, [field]: [selectedOption.value] };
						} else {
							const index = prev[field]?.findIndex((item) => {
								return item === selectedOption.value;
							});

							if (index !== -1) {
								return { ...prev };
							} else {
								return {
									...prev,
									[field]: [...prev[field], selectedOption.value],
								};
							}
						}
					});
					setFilter((prev) => {
						if (!prev[field] || prev[field]?.length === 0) {
							return { ...prev, [field]: [selectedOption.value] };
						} else {
							const index = prev[field]?.findIndex((item) => {
								return item === selectedOption.value;
							});

							if (index !== -1) {
								return { ...prev };
							} else {
								return {
									...prev,
									[field]: [...prev[field], selectedOption.value],
								};
							}
						}
					});
				} else {
					setGlobalSelectFilter((prev) => {
						const index = prev[field]?.findIndex((item) => {
							return item === selectedOption.value;
						});

						if (index !== -1) {
							const updatedArray = [...prev[field]];
							updatedArray.splice(index, 1);
							return { ...prev, [field]: updatedArray };
						} else {
							return { ...prev };
						}
					});
					setFilter((prev) => {
						const index = prev[field]?.findIndex((item) => {
							return item === selectedOption.value;
						});

						if (index !== -1) {
							const updatedArray = [...prev[field]];
							updatedArray.splice(index, 1);
							return { ...prev, [field]: updatedArray };
						} else {
							return { ...prev };
						}
					});
				}
			}
		}

		setSortField({});
	};

	useEffect(() => {
		getLevelId();
		getTitle();
	}, []);

	useEffect(() => {
		setFirstTimeRun(false);
	}, [filter, globalSelectFilter]);

	return (
		<div>
			<div className='px-2'>
				<h1 className='text-start px-2 text-sm font-semibold'>Title</h1>
				{filter?.title?.length > 0 && (
					<FilterBadges
						options={filter.title}
						field='title'
						handleRemove={handleRemove}
						optionLength={4}
					/>
				)}
				<div className='w-full my-2 rounded-lg'>
					<h3 className='pt-2 text-start px-2 text-gray-900 font-medium text-2xs'>
						Most Searched Titles
					</h3>
					<div className='px-2 pt-1 flex flex-wrap gap-1 items-center'>
						<div
							onClick={() =>
								handleSelect('title', {
									value: 'Manager',
									label: 'Manager',
									id: 'title',
								})
							}
							className={`cursor-pointer text-2xs font-medium rounded-lg py-1 px-2 ${
								filter?.title?.findIndex((e) => {
									if (typeof e === 'string') {
										return e === 'Manager';
									} else {
										return e.value === 'Manager';
									}
								}) !== -1
									? 'bg-blue-600 text-white hover:bg-blue-700'
									: 'text-gray-800 bg-gray-300 hover:bg-gray-400'
							}`}
						>
							Manager
						</div>
						<div
							onClick={() =>
								handleSelect('title', {
									value: 'Director',
									label: 'Director',
								})
							}
							className={`cursor-pointer text-2xs font-medium rounded-lg py-1 px-2 ${
								filter?.title?.findIndex((e) => {
									if (typeof e === 'string') {
										return e === 'Director';
									} else {
										return e.value === 'Director';
									}
								}) !== -1
									? 'bg-blue-600 text-white hover:bg-blue-700'
									: 'text-gray-800 bg-gray-300 hover:bg-gray-400'
							}`}
						>
							Director
						</div>
						<div
							onClick={() =>
								handleSelect('title', {
									value: 'Analyst',
									label: 'Analyst',
								})
							}
							className={`cursor-pointer text-2xs font-medium rounded-lg py-1 px-2 ${
								filter?.title?.findIndex((e) => {
									if (typeof e === 'string') {
										return e === 'Analyst';
									} else {
										return e.value === 'Analyst';
									}
								}) !== -1
									? 'bg-blue-600 text-white hover:bg-blue-700'
									: 'text-gray-800 bg-gray-300 hover:bg-gray-400'
							}`}
						>
							Analyst
						</div>
						<div
							onClick={() =>
								handleSelect('title', {
									value: 'Supervisor',
									label: 'Supervisor',
								})
							}
							className={`cursor-pointer text-2xs font-medium rounded-lg py-1 px-2 ${
								filter.title.findIndex((e) => {
									if (typeof e === 'string') {
										return e === 'Supervisor';
									} else {
										return e.value === 'Supervisor';
									}
								}) !== -1
									? 'bg-blue-600 text-white hover:bg-blue-700'
									: 'text-gray-800 bg-gray-300 hover:bg-gray-400'
							}`}
						>
							Supervisor
						</div>
						<div
							onClick={() =>
								handleSelect('title', {
									value: 'Chief Executive Officer',
									label: 'Chief Executive Officer',
								})
							}
							className={`cursor-pointer text-2xs font-medium rounded-lg py-1 px-2 ${
								filter?.title?.findIndex((e) => {
									if (typeof e === 'string') {
										return e === 'Chief Executive Officer';
									} else {
										return e.value === 'Chief Executive Officer';
									}
								}) !== -1
									? 'bg-blue-600 text-white hover:bg-blue-700'
									: 'text-gray-800 bg-gray-300 hover:bg-gray-400'
							}`}
						>
							CEO
						</div>
					</div>
					<h3 className='pt-3 text-start px-2 text-gray-700 font-medium text-2xs'>
						Or choose from the list
					</h3>
					<div className='px-2 pb-2 pt-1'>
						<Dropdown
							options={titleOptions}
							defaultLabel={'Search Title'}
							onSelect={handleSelect}
							field='title'
							disabled={false}
							title={'Job Titles:'}
							handleSearchOption={getTitle}
							searchLoading={isTitleSearch}
							filter={filter}
						/>
					</div>
				</div>
			</div>

			<div
				style={{ height: '1px' }}
				className='border-t border-slate-300 my-4'
			/>

			<div className='px-2'>
				<h1 className='text-start px-2 text-sm font-semibold'>
					Management Level
				</h1>
				<div className='w-full my-2 px-1 rounded-lg'>
					{isLevelSearch ? (
						<div className='px-1 text-start text-xs font-medium text-blue-600 flex gap-2 items-center'>
							<CircularProgress size={12} style={{ color: '#2f5eff' }} />
							Loading...
						</div>
					) : (
						<>
							<div className='flex items-center gap-2'>
								<div
									className={`rounded-full ${
										filter?.levelID && filter?.levelID?.length === 5
											? 'border-check-active'
											: 'border-check-light'
									}`}
								>
									<h3
										onClick={handleSelectAll}
										className='flex gap-1 cursor-pointer justify-center items-center py-1 pl-1 pr-2 text-start text-gray-900 font-semibold text-2xs'
									>
										<div className='custom-checkbox-filter'>
											<input
												type='checkbox'
												className='mt-0.5'
												checked={
													filter?.levelID && filter?.levelID?.length === 5
												}
											/>
											<div className='check-mark m-0 p-0'>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													class='w-2.5 h-2.5'
													viewBox='0 0 20 20'
													fill='currentColor'
													stroke='currentColor'
													stroke-width='1'
												>
													<path
														fill-rule='evenodd'
														d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
														clip-rule='evenodd'
													></path>
												</svg>
											</div>
										</div>
										Select All
									</h3>
								</div>
								<div
									className={`rounded-full ${
										filter?.levelID?.length === 3 &&
										['C-Level', 'Manager-Level', 'VP-Level'].every((value) => {
											return filter.levelID.some((element) => {
												if (typeof element === 'number') {
													return element === value;
												} else {
													return element === value;
												}
											});
										})
											? 'border-check-active'
											: 'border-check-light'
									}`}
								>
									<h3
										onClick={handleMostSearchML}
										className='flex gap-1 cursor-pointer items-center py-1 pl-1 pr-2 text-start text-gray-900 font-semibold text-2xs'
									>
										<div className='custom-checkbox-filter'>
											<input
												type='checkbox'
												className='mt-0.5'
												checked={
													filter?.levelID?.length === 3 &&
													['C-Level', 'Manager-Level', 'VP-Level'].every(
														(value) => {
															return filter?.levelID.some((element) => {
																if (typeof element === 'number') {
																	return element === value;
																} else {
																	return element === value;
																}
															});
														}
													)
												}
											/>
											<div className='check-mark'>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													class='w-2.5 h-2.5'
													viewBox='0 0 20 20'
													fill='currentColor'
													stroke='currentColor'
													stroke-width='1'
												>
													<path
														fill-rule='evenodd'
														d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
														clip-rule='evenodd'
													></path>
												</svg>
											</div>
										</div>
										Most Searched ML
									</h3>
								</div>
							</div>

							<div className='mt-3 flex flex-wrap gap-x-1 gap-y-2 items-center'>
								{levelId.length > 0 &&
									levelId.map((level, i) => (
										<div
											key={i}
											className={`rounded-full ${
												filter?.levelID &&
												filter?.levelID?.findIndex((e) => {
													if (typeof e === 'number') {
														return e === level.value;
													} else {
														return e === level.label;
													}
												}) !== -1
													? 'border-check-active'
													: 'border-check-light'
											}`}
										>
											<h3
												onClick={() => handleSelect('levelID', level)}
												className='flex gap-1 cursor-pointer py-1 pl-1 pr-2 items-center text-start text-gray-900 font-semibold text-2xs'
											>
												<div className='custom-checkbox-filter'>
													<input
														type='checkbox'
														className='mt-0.5'
														checked={
															filter?.levelID &&
															filter?.levelID?.findIndex((e) => {
																if (typeof e === 'number') {
																	return e === level.value;
																} else {
																	return e === level.label;
																}
															}) !== -1
														}
													/>
													<div className='check-mark'>
														<svg
															xmlns='http://www.w3.org/2000/svg'
															class='w-2.5 h-2.5'
															viewBox='0 0 20 20'
															fill='currentColor'
															stroke='currentColor'
															stroke-width='1'
														>
															<path
																fill-rule='evenodd'
																d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
																clip-rule='evenodd'
															></path>
														</svg>
													</div>
												</div>
												{level.label}
											</h3>
										</div>
									))}
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default JobTitleFilter;
